import { render, staticRenderFns } from "./TechToday.vue?vue&type=template&id=70042fce"
import script from "./TechToday.vue?vue&type=script&lang=js"
export * from "./TechToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports